import React, { useEffect, useState } from "react";
import ChatSeriesRenderer from "./ChatSeriesRenderer";
import showToast from "@utils/toast";
import { getRequest } from "src/service/api-services/api-services";
import { API_URL } from "src/service/config";
import Layout from "@components/layout";
import { currentLevelInfo, getFromMemory } from "@utils/storage.utils";
import { Plus } from "lucide-react";
import { useNavigate } from "react-router-dom";

const LessonActivityViewer = () => {
  const [activities, setActivities] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  const lessonId = getFromMemory("lessonId") as string;
  const levelId = getFromMemory("levelId") as string;
  const language = getFromMemory("language") as string;
  const currentLevel = currentLevelInfo();

  const navigate = useNavigate();

  const redirectUrl = (type: string) => {
    if (type === "TEXTCHAT") {
      return `/dashboard/levels/lessons/chat/series/create?type=TEXTCHAT`;
    } else if (type === "AUDIOCHAT") {
      return `/dashboard/levels/lessons/chat/series/create?type=AUDIOCHAT`;
    } else if (type === "IMAGECHAT") {
      return `/dashboard/levels/lessons/chat/series/create?type=IMAGECHAT`;
    } else {
      return `/dashboard/levels/lessons/chat/series/create?type=VIDEOCHAT`;
    }
  };

  useEffect(() => {
    getRequest<any>(
      `${API_URL}/interactive-lessons/${language}/levels/${levelId}/lessons/${lessonId}/activities`
    )
      .then((data) => {
        setActivities(data.result || []);
        setLoading(false);
      })
      .catch((e: any) => {
        setLoading(false);
        const message = e instanceof Error ? e.message : String(e);
        showToast(`${message}`, false);
      });
  }, []);

  if (loading)
    return (
      <p className="text-center text-gray-500">
        Loading chat series activities...
      </p>
    );

  return (
    <Layout>
      <div className="max-w-4xl mx-auto p-6 space-y-8">
        <div className="flex items-center justify-between mb-7">
          <h4>Lesson Chat List</h4>

          <div className="flex gap-3 pt-4">
            <button
              type="button"
              onClick={() => navigate(redirectUrl("TEXTCHAT"))}
              className="px-4 py-2 bg-brand text-white rounded-md text-sm flex items-center gap-2"
            >
              <Plus size={16} /> Add Text Chat
            </button>
            <button
              type="button"
              onClick={() => navigate(redirectUrl("IMAGECHAT"))}
              className="px-4 py-2 bg-brand text-white rounded-md text-sm flex items-center gap-2"
            >
              <Plus size={16} /> Add Image Chat
            </button>
            <button
              type="button"
              onClick={() => navigate(redirectUrl("AUDIOCHAT"))}
              className="px-4 py-2 bg-brand text-white rounded-md text-sm flex items-center gap-2"
            >
              <Plus size={16} /> Add Audio Chat
            </button>
            <button
              type="button"
              onClick={() => navigate(redirectUrl("VIDEOCHAT"))}
              className="px-4 py-2 bg-brand text-white rounded-md text-sm flex items-center gap-2"
            >
              <Plus size={16} /> Add Video Chat
            </button>
          </div>
        </div>

        {activities[0].activityType !== "ChatActivity" ? (
          <p className="text-center font-medium text-lg pt-6">
            No Chat Series Yet for this Lesson
          </p>
        ) : (
          <>
            {activities.map((activity, i) => (
              <div key={i} className="space-y-4">
                {activity.series.map((series: any) => (
                  <div
                    key={series.id}
                    className="bg-white p-4 rounded-lg shadow-lg"
                  >
                    <ChatSeriesRenderer series={series} />
                  </div>
                ))}
              </div>
            ))}
          </>
        )}
      </div>
    </Layout>
  );
};

export default LessonActivityViewer;
